/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useRef } from 'react';
// @ts-expect-error
import MathJax from 'react-mathjax2';
// @ts-expect-error
import Context from 'react-mathjax2/lib/Context';

interface IProps {
  expression?: string;
}

export const MathJaxContext: React.FC<IProps> = ({ expression }) => {
  const counter = useRef(0);

  const containsMath = expression?.includes('$$') || expression?.includes('@@') || expression?.includes('@');

  if (!containsMath) {
    return <>{expression}</>;
  }

  return (
    <Context
      input="tex"
      onError={(MathJax: any) => {
        if (counter.current < 3) {
          MathJax.Hub.Queue(MathJax.Hub.Typeset());
        }
        counter.current += 1;
      }}
      options={{
        messageStyle: 'none',
        asciimath2jax: {
          useMathMLspacing: true,
          delimiters: [['$$', '$$']],
          preview: 'none'
        },
        tex2jax: {
          inlineMath: [['@', '@']],
          displayMath: [['@@', '@@']],
          processEscapes: true,
          processEnvironments: true,
          preview: 'none'
        }
      }}
    >
      <MathJax.Text text={expression} />
    </Context>
  );
};
